import { render, staticRenderFns } from "./InviteResult.vue?vue&type=template&id=36d6917a&scoped=true&"
import script from "./InviteResult.vue?vue&type=script&lang=js&"
export * from "./InviteResult.vue?vue&type=script&lang=js&"
import style0 from "./InviteResult.vue?vue&type=style&index=0&id=36d6917a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d6917a",
  null
  
)

export default component.exports